import { useQuery } from '@tanstack/react-query'

import type { PostScoredLoansResponse } from '@api/postScoredLoans'

import { useBasin } from '@hooks/useBasin'

import getAuthHeaders from './utils/getAuthHeaders'
import { handleApiResponse } from './utils/handleApiResponse'

export interface ScoredLoansQueryOptions {
    customerId: string | undefined
    scoreId: string | undefined
    shouldFetch: boolean
}

export const useScoredLoansQuery = ({
    customerId,
    scoreId,
    shouldFetch,
}: ScoredLoansQueryOptions) => {
    const { ids } = useBasin()

    return useQuery<PostScoredLoansResponse>(
        ['scoredLoans', customerId, scoreId],
        () =>
            fetch(`${process.env.NEXT_PUBLIC_BASE_PATH}/api/scored-loans/`, {
                body: JSON.stringify({ customerId, scoreId }),
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    ...getAuthHeaders(ids),
                },
            }).then(handleApiResponse),
        {
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            retry: 3,
            enabled: !!customerId && !!scoreId && shouldFetch,
        }
    )
}
